export default "/assets/images/reading-girl.2f2286ed10cb28f7.webp";